import { render, staticRenderFns } from "./token-box2.vue?vue&type=template&id=19c15053&scoped=true&"
import script from "./token-box2.vue?vue&type=script&lang=js&"
export * from "./token-box2.vue?vue&type=script&lang=js&"
import style0 from "./token-box2.vue?vue&type=style&index=0&id=19c15053&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c15053",
  null
  
)

export default component.exports